import { createSelector } from 'reselect'
import { ApplicationState } from '..'

export const selectSubjects = createSelector(
  (state: ApplicationState) => state.schedule.booking,
  schedule => schedule.data.subjects
)
